import { useQuery } from '@tanstack/react-query'
import { api } from './api'

export interface MetadataClass {
  name: string
  value: string
}

export type DocumentType = {
  _id: string
  name: string
  metadata: MetadataClass[]
}

type DocumentTypes = {
  data: DocumentType[]
  page: number
  petPage: number
  totalPages: number
  total: number
}

async function fetchDocumentTypes(
  page?: number,
  perPage?: number,
  search?: string,
  sort?: string,
): Promise<DocumentTypes> {
  let sortName: any = 'name'
  let order: string = 'asc'

  if (sort) {
    var keyNames = Object.keys(sort)
    sortName = keyNames[0]
    order = sort[sortName]
  }

  const res = await api.get('/documentTypes', {
    params: {
      page,
      sort: sortName,
      order: order === 'desc' ? -1 : 1,
      perPage,
      search,
    },
  })
  return res.data
}

function useDocumentTypes(
  page: number | undefined,
  perPage: number | undefined,
  search: string | undefined,
  sort: string | "name",
) {
  return useQuery( 
    ['documentTypes', page, perPage, search, sort],
    () => fetchDocumentTypes(page, perPage, search, sort),
    {
      keepPreviousData: true,
      staleTime: 5000,
    },
  )
}

export default useDocumentTypes
